import Splide from "@splidejs/splide";

/** Figma node 1643:38738 — PICK UP スライダー */
export default function initPickup() {
  document.querySelectorAll(".js-p-pickup-slider").forEach((root) => {
    const section = root.closest(".p-pickup");
    const progressBar = section?.querySelector(".js-p-pickup-progress-bar");
    const prevBtn = section?.querySelector(".js-p-pickup-prev");
    const nextBtn = section?.querySelector(".js-p-pickup-next");
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  const originalSlideCount = root.querySelectorAll(
    ":scope > .splide__track > .splide__list > .splide__slide"
  ).length;

  const splide = new Splide(root, {
    type: "loop",
    perPage: 2,
    perMove: 1,
    gap: "20px",
    pagination: false,
    arrows: false,
    drag: true,
    autoplay: !prefersReducedMotion,
    interval: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    speed: 600,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    breakpoints: {
      1024: {
        perPage: 1,
        gap: "12px",
        padding: { right: "1.25rem" },
      },
    },
  });

  const ensureSlidesForLoop = () => {
    const { Slides } = splide.Components;
    const perPage = splide.options.perPage;
    let slides = Slides.get(true);

    while (slides.length <= perPage) {
      const html = slides
        .slice(0, originalSlideCount)
        .map(({ slide }) => slide.outerHTML);
      Slides.add(html);
      slides = Slides.get(true);
    }
  };

  const getActiveIndex = () => {
    const length = originalSlideCount;
    if (length <= 0) return 0;
    return ((splide.index % length) + length) % length;
  };

  const updateProgress = () => {
    if (!progressBar) return;
    if (originalSlideCount <= 0) return;
    const index = getActiveIndex();
    progressBar.style.width = `${((index + 1) / originalSlideCount) * 100}%`;
  };

  const updateArrows = () => {
    if (prevBtn) prevBtn.disabled = false;
    if (nextBtn) nextBtn.disabled = false;
  };

  splide.on("mounted updated", ensureSlidesForLoop);

  splide.on("mounted move resized updated", () => {
    updateProgress();
    updateArrows();
  });

  prevBtn?.addEventListener("click", () => splide.go("<"));
  nextBtn?.addEventListener("click", () => splide.go(">"));

    splide.mount();
  });
}
